
import { defineComponent, ref, computed, watch } from 'vue'
import MembersShowEditMemberPersonalInfo from '@/components/members/show-edit-member-personal-info.vue'
import MembersShowMemberOrganizationInfo from '@/components/members/show-member-organization-info.vue'
import MembersShowMemberAccessesList from '@/components/members/show-member-accesses-list.vue'
import { useMemberModule } from '@/modules/members'
import { useRoute, useRouter } from 'vue-router'
import { MembersRouteNames, OrganizationsRouteNames } from '@/router/routes-names'
import ConfirmDeletionDialog from '@/components/_shared/dialogs/confirm-deletion-dialog.vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { deleteSingleMember } from '@/modules/members/api'

export default defineComponent({
    name: 'view-members-show-member',
    components: {
        MembersShowEditMemberPersonalInfo,
        MembersShowMemberOrganizationInfo,
        MembersShowMemberAccessesList
    },
    async setup () {
        const route = useRoute()
        const router = useRouter()
        const $q = useQuasar()
        const { getMember, member } = useMemberModule()

        const isMemberWithOrganization = computed(() => member.value?.organizationId)

        await getMember(route.params.memberId as string)
        const memberModel = {
            memberId: member.value?.id,
            firstName: member.value?.firstName,
            lastName: member.value?.lastName,
            email: member.value?.email,
            jobTitleId: member.value?.jobTitleId,
            preferredLanguage: member.value?.preferredLanguage,
            organizationId: member.value?.organizationId,
            allowMarketingCommunication: member.value?.allowMarketingCommunication
        }

        const membersListRoute = route.params.organizationId ? {
            name: OrganizationsRouteNames.MEMBERS,
            params: { organizationId: route.params.organizationId, restoreFilters: 1 },
            query: { page: route.query.page }
        } : {
            name: MembersRouteNames.LIST,
            query: { page: route.query.page, restoreFilters: 1 }
        }

        const moveToList = () => router.push(membersListRoute)
        const onDeleteMember = async (member: typeof memberModel) => {
            $q.dialog({
                component: ConfirmDeletionDialog,
                componentProps: {
                    entityType: 'member',
                    identifier: `"${member.firstName} ${member.lastName}"`,
                    deleteCallback: async function () {
                        await deleteSingleMember(member.memberId as string)
                        await moveToList()
                    }
                }
            })
        }

        return {
            route,
            member,
            memberModel,
            isMemberWithOrganization,
            MembersRouteNames,
            membersListRoute,
            tab: ref('personal_info'),
            onDeleteMember
        }
    }
})
